// @flow
import * as React from 'react';
import { Checkbox, FormGroup } from 'react-bootstrap';

import type { Props } from './props';
import style from './style';

const RadioStation = ({ radioData, onChange, value }: Props): React.Element<any> => (
  <FormGroup style={style.content}>
    <Checkbox
      inline
      checked={value}
      onChange={(event: Object) => onChange(radioData, event.target.checked)}
    >
      {radioData.title}
    </Checkbox>
  </FormGroup>

);

export default RadioStation;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Radio/components/RadioStationsGroup/components/RadioStation/RadioStation.js